/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { statusGetStatusUsage } from "../../funcs/statusGetStatusUsage.js";
import { GetStatusUsageRequest$zodSchema } from "../../models/getstatususageop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetStatusUsageRequest$zodSchema.optional(),
};

export const tool$statusGetStatusUsage: ToolDefinition<typeof args> = {
  name: "status-get-status-usage",
  description: `获取API端点使用统计

想知道哪个API接口最受欢迎吗？这个接口提供了详细的“账单”。

## 功能概述
此接口用于获取每个API端点（Endpoint）的使用情况统计。你可以查询所有端点的列表，也可以通过 \`path\` 参数指定查询某一个特定端点。返回信息包括调用次数和平均处理时长`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await statusGetStatusUsage(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
